import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { cn } from '@/lib/utils'

interface HorizontalBarChartProps {
  data: object[]
  xKey: string
  yKey: string
  height?: number
  title?: string
  color?: string
  className?: string
}

export function HorizontalBarChart({ data, xKey, yKey, height = 200, title, color = 'hsl(var(--primary))', className }: HorizontalBarChartProps) {
  return (
    <div className={cn('rounded-xl border border-border bg-card p-5', className)}>
      {title && <h3 className="mb-4 text-sm font-medium text-muted-foreground">{title}</h3>}
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 20, bottom: 0, left: 60 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 12 }} className="text-muted-foreground" tickFormatter={(v: number) => `${v}%`} />
          <YAxis type="category" dataKey={xKey} tick={{ fontSize: 12 }} className="text-muted-foreground" />
          <Tooltip contentStyle={{ backgroundColor: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: '8px', fontSize: '12px' }} />
          <Bar dataKey={yKey} fill={color} radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
